import type { AuthResultDto, BawabahCallbackInput } from "@mandoob/shared";

import {
  type MutationHookOptions,
  type RequestOptions,
  useApiMutation,
} from "@/api/query-helpers";
import { api } from "@/lib/api-client";

const BASE = "/api/auth";

/** Exchanges a Bawabah sessionId for an app JWT + driver profile. */
export const bawabahCallback = (
  data: BawabahCallbackInput,
  options?: RequestOptions,
) =>
  api<AuthResultDto>(
    { url: `${BASE}/bawabah/callback`, method: "POST", data },
    options,
  );

export const useBawabahCallback = (
  options?: MutationHookOptions<AuthResultDto, BawabahCallbackInput>,
) => useApiMutation((data, request) => bawabahCallback(data, request), options);

/** Whether the store-review bypass is configured (hides the entry if not). */
export const getReviewLoginEnabled = (options?: RequestOptions) =>
  api<{ enabled: boolean }>(
    { url: `${BASE}/review-login`, method: "GET" },
    options,
  );

/** Store-review bypass: signs into the demo driver with email + code. */
export const reviewLogin = (
  data: { email: string; code: string },
  options?: RequestOptions,
) =>
  api<AuthResultDto>(
    { url: `${BASE}/review-login`, method: "POST", data },
    options,
  );
